import React, {FC, Suspense, useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Route, Routes, Navigate} from 'react-router';

import {Spinner} from '#blocks/spinner';
import {getQueryParams} from '#utils/getQuery';
import {useSoundOnHold} from 'hooks/useSoundOnHold';
import {Store} from 'reducers';

const SupportForm = React.lazy(() => import('../../../SupportForm/src/components2/support/support-form/SupportForm'));
const SupportDriverForm = React.lazy(() => import('../../../SupportForm/src/components2/support/support-driver-form/SupportDriverForm'));
const SupportDriveUsersForm = React.lazy(() => import('../../../SupportForm/src/components2/support/support-drive-users-form/SupportDriveUsersForm'));

const App: FC = () => {
    // Мок завершения звонка для тестирования работы в поствызывной обработке в отдельной формие
    const isCallEndedMock = useMemo(() => Boolean(getQueryParams<{is_call_ended: string}>()?.is_call_ended), []);
    const isCallEnded = useSelector<Store>(state => state.call.isEnded) || isCallEndedMock;
    const isInIframe = window.self !== window.top;

    useSoundOnHold();

    const onSubmit = useCallback(() => {
        window.parent.postMessage(JSON.stringify({message: 'sent', name: 'custom'}), '*');
    }, []);

    return (
        <Suspense fallback={<Spinner/>}>
            <Routes>
                <Route path="/" element={<Navigate to={'/users'}/>}/>
                <Route
                    path={'/users'}
                    element={<SupportForm disabled={!isCallEnded && isInIframe} onSubmit={onSubmit}/>}
                />
                <Route
                    path={'/drivers'}
                    element={(
                        <SupportDriverForm
                            isIntegaratedForm={isInIframe}
                            isCallActive={!isCallEnded}
                            onFormClose={onSubmit}
                        />
                    )}
                />
                <Route
                    path={'/drive-users'}
                    element={(
                        <SupportDriveUsersForm
                            isIntegaratedForm={isInIframe}
                            isCallActive={!isCallEnded}
                            onSubmit={onSubmit}
                        />
                    )}
                />
            </Routes>
        </Suspense>
    );
};

export default App;
